<script setup lang="ts">
import type { ReportColumn } from '../../models/column.types'

import { useI18n } from '@/shared/i18n'
import { Checkbox, MetricView } from '@/shared/ui'

defineProps<{
  columns: readonly ReportColumn[]
  visibleFields: ReadonlySet<string>
  expandedFields: ReadonlySet<string>
  expandableFields: readonly string[]
  requiredFields: readonly string[]
}>()

const emit = defineEmits<{
  visible: [field: string, value: boolean]
  expanded: [field: string, value: boolean]
}>()

const { t } = useI18n()
</script>

<template>
  <ol class="customize-column-list m-0 p-0 list-none">
    <li
      v-for="column in columns"
      :key="column.field"
      class="customize-column-list__row group flex min-h-9 items-center gap-sm py-xs ps-xl pe-xs text-sm text-fg"
    >
      <Checkbox
        :model-value="visibleFields.has(column.field)"
        :aria-label="column.header"
        :disabled="requiredFields.includes(column.field)"
        tone="accent"
        @update:model-value="emit('visible', column.field, $event)"
      />
      <MetricView :column="column" :size="20" class="min-w-0 flex-1" />
      <div
        class="customize-column-list__actions flex items-center gap-2xs opacity-40 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100"
      >
        <div
          v-if="expandableFields.includes(column.field)"
          class="customize-column-list__comparison flex items-center gap-2xs"
        >
          <span class="sr-only">{{ t('reports.table.compare') }}</span>
          <Checkbox
            :model-value="expandedFields.has(column.field)"
            :aria-label="t('reports.table.expandComparison', { column: column.header })"
            :disabled="!visibleFields.has(column.field)"
            @update:model-value="emit('expanded', column.field, $event)"
          />
        </div>
      </div>
    </li>
  </ol>
</template>
